if($('#shootMachinesDatatable').length > 0) {
    url = $('#shootMachinesDatatable').attr('data-url');
    dt = $("#shootMachinesDatatable").DataTable({
        searchDelay: 500,
        order: [[0, 'asc']],
        language: window.datatableLanguage,
        searching: true,
        serverSide: true,
        processing: true,
        responsive: true,
        ajax: url,
        select: {
            style: 'os',
            selector: 'td:first-child',
            className: 'row-selected'
        },
        columns: [
            { data : 'number'},
            { data : 'label'},
            { data : 'user'},
            { data : 'type'},
            { data : 'shoots'},
            { data : 'status'},
            { data : 'actions'}
        ],
        columnDefs: [
            {
                targets: 0,
                orderable: true
            },
            {
                targets: 1,
                orderable: true
            },
            {
                targets: 2,
                orderable: true
            },
            {
                targets: 3,
                orderable: true
            },
            {
                targets: 4,
                orderable: true
            },
            {
                targets: 5,
                orderable: true
            },
            {
                targets: 6,
                orderable: false
            }
        ]
    });

    const filterSearch = document.querySelector('[data-kt-shootMachinesDatatable-table-filter="search"]');
    filterSearch.addEventListener('keyup', function (e) {
        dt.search(e.target.value).draw();
    });
}
